<template>
    <rkm-form ref="Form">
        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    :validations="validations.observacoes"
                    rows="6"
                    v-model="especialidade.observacoes"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
export default {
    computed: {
        validations() {

            return {
                observacoes: { max: 1000 },
            }
        },
    },
    methods: {
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.originalEspecialidade.observacoes = this.especialidade.observacoes

                    this.$emit('save')
                })
        },
    },
    props: {
        originalEspecialidade: { type: Object, required: true },
        especialidade: { type: Object, required: true },
    },
}
</script>